import { useDispatch, useSelector } from "react-redux";

import { IReduxAppState } from "../reducers";
import { ITask } from "../yoello-lib/modules/interfaces/ITask";
import { HTTPMethods } from "../yoello-lib/modules/API/API";
import { useEffect, useState } from "react";
import { useAPIV2 } from "../yoello-lib/modules/API2/useAPIv2";
import { APIMerchantDashboard } from "../yoello-lib/modules/API2/APIDefs/MerchantAPIDefs";
import { setOutstandingBody } from "../yoello-lib/modules/redux/actions/oustanding.actions";

const useTask = () => {
  const venueID = useSelector((state: IReduxAppState) => state.selectedVenueId);
  const doneTasks = useSelector((state: IReduxAppState) => state.outstanding.doneTasks);
  const totalTasks = useSelector((state: IReduxAppState) => state.outstanding.totalTasks);
  const [isTasksLoading, setIsTasksLoading] = useState<boolean>(false)
  const dispatch = useDispatch();

  const { callAPI, apiData } = useAPIV2<ITask[]>(
    APIMerchantDashboard.venueMerchant,
    {
      onMountDisabled:true
    }
  );

  useEffect(() => {
    if (!venueID || isTasksLoading) {
      return;
    }
    callTasks();
    //eslint-disable-next-line
  }, [venueID]);

  useEffect(()=>{
    if (Array.isArray(apiData)) {
      dispatch(setOutstandingBody({ tasks: apiData as ITask[], venueId: venueID }));
    }
    //eslint-disable-next-line
  }, [apiData])

  const callTasks = () => {
    setIsTasksLoading(true)
    callAPI(HTTPMethods.GET, { query: `${venueID}/onboarding/status`}).finally(()=>{
      setIsTasksLoading(false)
    });
  };


  return { doneTasks, totalTasks, increaseDoneTasks: callTasks , isTasksLoading };
};

export default useTask;
